import React, { useState, useEffect, useMemo, Suspense, lazy } from "react";
import GoogleAuth from "../../../confrigration/googleAuth";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import "../../css/index.scss";
import "../../css/rankTracking.css";
import "../../css/loader.css";
import axios from "axios";
import {
  GET_Google_Console_Data,
  GET_Google_Console_Site,
  POST_Google_Console_Data,
} from "../../../services/constants";
import { formatDate } from "../../share/upDater/constant";
import SingleLineChart from "../../share/charts/line-chart";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import ListItemButton from "@mui/material/ListItemButton";
import ToolTip from "../../share/components/tooltip";
import googleConsoleImg from "../../Assets/home/google-search-console.png";

import backIcon from "../../Assets/common/back.svg";
import { ZustandStore } from "../../../store/zustand-store";
import Checkbox from "@mui/material/Checkbox";
import { getDomainNameAndLang } from "../../../helperJs/getCountryFlag";
import FallbackLoader from "../../share/components/FallbackLoader";
import googleAnalyticsImg from "../../Assets/google-analytics/Logo_Google_Analytics.svg.png";
import DropdownMenu from "../../../common/components/dropdown";

import Wizard from "@semcore/wizard";
import { Flex } from "@semcore/flex-box";
import { Text } from "@semcore/typography";
import SemButton from "../../../common/components/Button";

const LazyProjectList = lazy(() =>
  import("../../share/dropdown-menu/ProjectList")
);
const LazySearchConsoleTable = lazy(() =>
  import("../../share/tables/google-analytics/SearchConsoleTable")
);

const GoogleData = () => {
  const email = localStorage.getItem("admin_mail");
  const websiteurl = useSelector((state) => state.websiteurl);
  const userAnalyticData = useSelector((state) => state.userAnalyticData);
  const userAnalyticLogin = useSelector((state) => state.userAnalyticLogin);
  const { property_name, google_console_data } = ZustandStore((state) => state);

  const [value, setValue] = React.useState(0);
  const [dropDownOption, setDropdownOption] = React.useState("Last 1 week");
  const [Loader, setLoader] = React.useState(false);
  const [consoleStatus, setConsoleStatus] = useState(false);
  const [getConsole, setGetConsole] = useState(false);
  const [siteData, setSiteData] = useState([]);
  const [consoleSite, setConsoleSite] = useState("");
  const [showChartData, setShowChartData] = useState({
    clicks: true,
    impressions: true,
    ctr: false,
    position: false,
  });

  const website_domain = useMemo(() => {
    const domain = getDomainNameAndLang(websiteurl);
    return domain?.domain;
  }, [websiteurl]);

  useEffect(() => {
    const dominUpdate = () => {
      setGetConsole(false);
      setConsoleStatus(false);
      setSiteData([]);
      setConsoleSite("");
      ZustandStore.setState({
        property_name: [],
      });
    };
    dominUpdate();
  }, [website_domain]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const getConsoleDataList = (signal) => {
    if (email === null) return;
    if (google_console_data?.length > 0) return;
    axios
      .get(GET_Google_Console_Site(email, website_domain), {
        signal,
      })
      .then((response) => {
        if (response?.data?.length > 0) {
          ZustandStore.setState({
            google_console_data: response.data,
          });
          setConsoleStatus(false);
        }
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    const controller = new AbortController();
    if (google_console_data?.length === 0 && email) {
      getConsoleDataList(controller.signal);
      const interval = 30000; // 60000 milliseconds = 1 minute
      const intervalId = setInterval(() => {
        getConsoleDataList(controller.signal);
      }, interval);
      return () => {
        controller.abort();
        clearInterval(intervalId);
      };
    }
  }, [email, google_console_data]);

  useEffect(() => {
    setLoader(true);
    const intervalId = setTimeout(() => {
      setLoader(false);
    }, 200);
    return () => clearInterval(intervalId);
  }, [userAnalyticLogin]);

  const trafficDays = [
    { location_name: "Last 1 week", day: 7, value: 0 },
    { location_name: "Last 30 days", day: 30, value: 1 },
    { location_name: "Last 3 month", day: 90, value: 2 },
    { location_name: "Last 6 month", day: 180, value: 3 },
    { location_name: "Last 1 year", day: 365, value: 4 },
    { location_name: "All Data", day: 0, value: 5 },
  ];

  const default_date = trafficDays?.find(
    (item) => item.location_name === dropDownOption
  );
  const show_data_upto =
    default_date?.day === 0 ? userAnalyticData?.length : default_date?.day;

  const handleDateUpdate = (e) => {
    setDropdownOption(e);
  };

  const chart_label = userAnalyticData?.map((item) => {
    return formatDate(item.date);
  });

  const arrayModification = (arr) => {
    const reversedArray = [...arr].reverse();
    const slicedArray = reversedArray.slice(0, show_data_upto);
    const finalArray = slicedArray.reverse();
    return finalArray;
  };

  const chartLabel =
    chart_label?.length > 0 ? arrayModification(chart_label) : [];

  const dataLoadedFrom =
    chartLabel?.length > 0
      ? `${chartLabel?.[0]} - ${chartLabel?.[chartLabel?.length - 1]}`
      : false;

  const chart_mobile_dataset = userAnalyticData?.map((item) => {
    return item.mobile;
  });
  const chart_default_dataset = userAnalyticData?.map((item) => {
    return item.total_data;
  });
  const chart_desktop_dataset = userAnalyticData?.map((item) => {
    return item.desktop;
  });

  const handleSampleData = (array) => {
    return array?.length > 0 ? arrayModification(array) : [];
  };

  const selected_chart_dataset = [
    {
      label: "Users",
      data: handleSampleData(chart_default_dataset),
      yAxisID: "y",
      tension: 0.4,
      fill: true,
      borderWidth: 3,
      borderColor: "#6366F1",
      pointBorderColor: "#6366F1",
      pointBackgroundColor: "#6366F1",
      pointRadius: 0,
      pointHoverRadius: 3,
    },
    {
      label: "Desktop",
      data: handleSampleData(chart_desktop_dataset),
      fill: true,
      tension: 0.4,
      yAxisID: "y",
      borderWidth: 3,
      borderColor: "#6366F1",
      pointBorderColor: "#6366F1",
      pointBackgroundColor: "#6366F1",
      pointRadius: 0,
      pointHoverRadius: 3,
    },
    {
      label: "Mobile",
      data: handleSampleData(chart_mobile_dataset),
      fill: true,
      tension: 0.4,
      yAxisID: "y",
      borderWidth: 3,
      borderColor: "#6366F1",
      pointBorderColor: "#6366F1",
      pointBackgroundColor: "#6366F1",
      pointRadius: 0,
      pointHoverRadius: 3,
    },
  ];

  const options = {
    maintainAspectRatio: false,
    responsive: true,
    interaction: { mode: "index", intersect: false },
    plugins: {
      legend: {
        position: "top",
        display: false,
      },
      title: {
        display: true,
      },
      axisY: {
        gridDashType: "dash",
      },
      tooltip: {
        enabled: userAnalyticData?.length > 0 ? true : false,
        boxPadding: 5,
        cornerRadius: 1,
        caretSize: 10,
        padding: 10,
        margin: 0,
        boxHeight: 30,
        borderColor: "rgba(0, 0, 0, 0.2)",
        borderWidth: 1,
        borderRadius: 5,
        boxWidth: 10,
        titleColor: "black",
        bodyColor: "black",
        bodyFont: {
          size: 14,
          weight: 500,
          font: "Lato",
        },
        bodySpacing: 7,
        usePointStyle: true,
        backgroundColor: "#FFFFFF",
        titleFont: {
          size: 14,
          weight: 400,
          font: "Lato",
        },
      },
    },
    scales: {
      y: {
        type: "linear",
        display: true,
        position: "left",
        reverse: false,
        border: {
          display: false,
        },
        beginAtZero: true,
        ticks: {
          maxTicksLimit: 8,
          autoSkip: false,
          min: 0,
          max: 500,
          stepSize: 100,
          beginAtZero: true,
        },
        grid: {
          display: true,
          tickBorderDash: [2, 15], // also for the tick, if long enough
          tickLength: 10, // just to see the dotted line
          tickWidth: 2,
        },
      },
      x: {
        ticks: {
          display: true,
          maxTicksLimit: 6,
          min: 5,
          max: 6,
          autoSkip: true,
          beginAtZero: false,
        },
        grid: {
          display: false,
          tickBorderDash: [2, 15], // also for the tick, if long enough
          tickLength: 10, // just to see the dotted line
          tickWidth: 2,
        },
      },
    },
    cubicInterpolationMode: "monotone",
  };

  const chart_data = {
    label: "",
    labels: chartLabel,
    dataSet: [selected_chart_dataset?.[value]],
    gradient: true,
  };

  const getGoogleConsoleData = async () => {
    axios
      .get(GET_Google_Console_Data(email, website_domain))
      .then((response) => {
        setSiteData(response.data);
        setGetConsole(true);
      })
      .catch((error) => console.error(error));
  };

  const postGoogleConsoleData = async () => {
    const config = {
      email,
      refresh_token: siteData[0]?.refresh_token,
      site: consoleSite,
      domain: website_domain,
    };
    setConsoleStatus(true);
    setSiteData([]);
    axios.post(POST_Google_Console_Data(config)).catch(() => {});
  };

  const searchConsoleChartData = useMemo(() => {
    if (!google_console_data?.length) return [];

    const keys = ["date", "clicks", "impressions", "ctr", "position"];
    const chartData = keys.reduce((acc, key) => {
      acc[key] = google_console_data[0]?.data?.map((data) => data[key]) || [];
      return acc;
    }, {});

    return {
      ...chartData,
      label: google_console_data?.[0]?.site,
    };
  }, [google_console_data]);

  const colors = {
    impressions: "#ec5a38",
    clicks: "#3b7cdf",
    position: "#51ae54",
    ctr: "#f8d748",
  };

  const chartShowDataType = useMemo(() => {
    const totalClicks = sumArray(searchConsoleChartData?.clicks).sum || 0;
    const totalImpressions =
      sumArray(searchConsoleChartData?.impressions).sum || 0;
    const averageCtr =
      sumArray(searchConsoleChartData?.ctr)?.avg?.toFixed(3) + "%" || 0;
    const avgPosition =
      sumArray(searchConsoleChartData?.position).avg?.toFixed(2) || 0;

    return [
      {
        title: "Total Clicks",
        datakey: "clicks",
        value: totalClicks,
        isShow: showChartData.clicks,
        backgroundColor: showChartData.clicks ? "#3b7cdf" : "#F0F0F0",
        color: showChartData.clicks ? "white" : "#696969",
      },
      {
        title: "Total Impressions",
        datakey: "impressions",
        value: totalImpressions,
        isShow: showChartData.impressions,
        backgroundColor: showChartData.impressions ? "#ec5a38" : "#F0F0F0",
        color: showChartData.impressions ? "white" : "#696969",
      },
      {
        title: "Average CTR",
        datakey: "ctr",
        value: averageCtr,
        isShow: showChartData.ctr,
        backgroundColor: showChartData.ctr ? "#f8d748" : "#F0F0F0",
        color: showChartData.ctr ? "white" : "#696969",
      },
      {
        title: "Average Position",
        datakey: "position",
        value: avgPosition,
        isShow: showChartData.position,
        backgroundColor: showChartData.position ? "#51ae54" : "#F0F0F0",
        color: showChartData.position ? "white" : "#696969",
      },
    ];
  }, [searchConsoleChartData, showChartData]);

  function sumArray(numbers) {
    if (numbers?.length > 0) {
      const sum = numbers.reduce(
        (accumulator, currentValue) => accumulator + currentValue,
        0
      );
      const avg = sum / numbers.length;

      return {
        sum: sum >= 1000 ? (sum / 1000).toFixed(2) + "k" : sum.toFixed(2),
        avg: avg,
      };
    } else {
      return { sum: 0, avg: 0 };
    }
  }

  const handleCheckboxChange = (key) => {
    setShowChartData((prev) => {
      // Count the number of `true` values in the current state
      const trueCount = Object.values(prev).filter((value) => value).length;

      // If only one true value remains and the user tries to turn it off, prevent the change
      if (trueCount === 1 && prev[key]) {
        return prev;
      }

      // Otherwise, toggle the selected key
      return {
        ...prev,
        [key]: !prev[key],
      };
    });
  };

  const baseConOptions = {
    maintainAspectRatio: false,
    responsive: true,
    interaction: { mode: "index", intersect: false },
    plugins: {
      legend: {
        position: "top",
        display: false,
      },
      title: {
        display: true,
      },
      axisY: {
        gridDashType: "dash",
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            const datasetLabel = context.dataset.label || "";
            const value = context.raw; // Access the raw data value

            if (datasetLabel.toLowerCase() === "position") {
              return `${datasetLabel}: ${value.toFixed(2)}`; // Format position to 2 decimal places
            }

            if (datasetLabel.toLowerCase() === "ctr") {
              return `${datasetLabel}: ${
                value > 0 ? value.toFixed(3) : value
              }%`; // Format ctr to 1 decimal place
            }

            return `${datasetLabel}: ${value}`; // Default formatting
          },
        },
        boxPadding: 5,
        cornerRadius: 10,
        caretSize: 10,
        padding: 10,
        margin: 10,
        boxHeight: 30,
        borderWidth: 4,
        boxWidth: 4,
        titleColor: "black",
        bodyColor: "black",
        bodyFont: {
          size: 16,
        },
        bodySpacing: 10,
        backgroundColor: "#F0F0F0",
        usePointStyle: true,
        background: "linear-gradient(rgb(209,157,32), rgba(0, 0, 255, 0.5)", //
        titleFont: {
          weight: "bold",
          size: 15,
        },
      },
    },
    scales: {
      y: {
        type: "linear",
        display: false,
        position: "left",
        title: {
          display: true,
          text: "",
          font: { size: 14, weight: 500 },
        },
        ticks: {
          maxTicksLimit: 8,
          autoSkip: true,
          min: 0,
          max: 100,
          stepSize: 30,
          beginAtZero: true,
          size: 16,
          weight: 500,
        },
        grid: {
          display: false,
        },
      },
      y1: {
        type: "linear",
        display: false,
        position: "right",
        title: {
          display: true,
          text: "",
          font: { size: 14, weight: 500 },
        },
        ticks: {
          maxTicksLimit: 8,
          autoSkip: true,
          min: 3,
          max: 100,
          stepSize: 30,
          beginAtZero: true,
          size: 16,
          weight: 500,
        },
        grid: {
          display: false,
        },
      },
    },
  };

  const updateYAxisMappingAndOptions = (showChartData) => {
    const selectedKeys = Object.keys(showChartData).filter(
      (key) => showChartData[key]
    );
    const yAxisMapping = {};
    const displayLeftRightAxes = selectedKeys.length <= 2; // Show axes only if 1 or 2 keys are selected

    const con_options = {
      ...baseConOptions, // Start with your base chart options
      scales: {
        y: {
          ...baseConOptions.scales.y,
          display: displayLeftRightAxes && selectedKeys.length > 0, // Display left axis only if at least one key is selected and within limit
          title: {
            ...baseConOptions.scales.y.title,
            text: displayLeftRightAxes ? selectedKeys[0] || "" : "", // Set dynamic title
          },
        },
        y1: {
          ...baseConOptions.scales.y1,
          display: displayLeftRightAxes && selectedKeys.length > 1, // Display right axis only if two keys are selected
          title: {
            ...baseConOptions.scales.y1.title,
            text: displayLeftRightAxes ? selectedKeys[1] || "" : "", // Set dynamic title
          },
        },
        y2: {
          type: "linear",
          display: false,
        },
        y3: {
          type: "linear",
          display: false,
        },
        x: {
          ticks: {
            display: true,
            maxTicksLimit: 6,
            autoSkip: true,
            beginAtZero: false,
          },
          grid: {
            display: false,
            tickBorderDash: [2, 15], // also for the tick, if long enough
            tickLength: 10, // just to see the dotted line
            tickWidth: 2,
          },
        },
      },
    };

    if (displayLeftRightAxes) {
      if (selectedKeys.length > 0) {
        yAxisMapping[selectedKeys[0]] = "y"; // Map first key to left axis
      }
      if (selectedKeys.length > 1) {
        yAxisMapping[selectedKeys[1]] = "y1"; // Map second key to right axis
      }
    }

    return { yAxisMapping, con_options };
  };

  const { yAxisMapping, con_options } = useMemo(
    () => updateYAxisMappingAndOptions(showChartData),
    [showChartData]
  );

  const con_chart_data = {
    label: searchConsoleChartData?.label || "",
    labels: searchConsoleChartData?.date || [],
    gradient: false,
    dataSet: Object.keys(showChartData)
      .filter((key) => showChartData[key]) // Filter datasets based on active chart data
      .map((key) => ({
        label: key.charAt(0).toUpperCase() + key.slice(1),
        data: searchConsoleChartData[key] || [],
        borderColor: colors[key],
        pointBorderColor: colors[key],
        fill: "start",
        yAxisID: yAxisMapping[key], // Map to dynamic axis if available
        pointRadius: 0,
        borderWidth: 2,
        pointHoverRadius: 0,
        backgroundColor: "transparent",
        pointBackgroundColor: "#FFFFFF",
      })),
  };

  const trafficDataMenu = useMemo(() => {
    return {
      value: dropDownOption,
      placeholder: "Select range",
      disabled: false,
      data: trafficDays,
      height: "35px",
      loading: false,
    };
  }, [dropDownOption, trafficDays]);

  return (
    <main className="main-pd rank-tracking-container dashboard-app-container">
      <Wizard
        visible={
          siteData?.length > 0 && siteData?.[0]?.console_data?.length > 0
        }
        step={1}
        w={"90%"}
        h={"550px"}
        wMax={"800px"}
        onClose={() => setSiteData([])}
        className="add-google-acc-popup"
        key={"add-google-acc-popup"}
      >
        <Wizard.Sidebar title="Select Google Site" w={"25%"} />
        <Wizard.Content tag={Flex} direction="column" w={"75%"} p={4}>
          <Wizard.Step step={1}>
            <Box className="mt-4">
              <Grid container spacing={2} columns={12} className="mb-2">
                <Grid item xs={12} md={12}>
                  <Flex gap={2}>
                    <Text fontWeight={600} size={400} mb={0} mr={"auto"}>
                      Select Site
                      <ToolTip
                        title="List of Properties attached with your Google Analyics
                                              Account, select property for which you want data to be
                                              shown."
                      />
                    </Text>
                  </Flex>
                  {siteData?.length === 0 ||
                  siteData?.console_data?.length === 0 ? (
                    <h1>no data</h1>
                  ) : (
                    <List
                      component="nav"
                      aria-label="select-google-property"
                      className="overflow-auto p-0 list-border h-100"
                      sx={{ maxHeight: 350, minHeight: 300 }}
                    >
                      {siteData[0]?.console_data?.map((item, index) => {
                        return (
                          <React.Fragment key={`google-console-list${index}`}>
                            <ListItemButton
                              selected={item === consoleSite}
                              sx={{
                                "&:hover": {
                                  backgroundColor: "rgba(240, 242, 255, 1)",
                                },
                              }}
                              onClick={() => setConsoleSite(item)}
                            >
                              <ListItemText
                                primary={item}
                                sx={{
                                  "& .MuiListItemText-primary": {
                                    fontSize: "1.2em",
                                    color: "#365486",
                                    fontWeight: "600",
                                  },
                                  "& .MuiListItemText-secondary": {
                                    fontSize: "1em",
                                    color: "black",
                                  },
                                }}
                              />
                            </ListItemButton>
                            <Divider />
                          </React.Fragment>
                        );
                      })}
                    </List>
                  )}
                </Grid>
              </Grid>
              <SemButton
                name="Submit"
                title="Submit"
                onClick={() => postGoogleConsoleData()}
              />
            </Box>
          </Wizard.Step>
        </Wizard.Content>
      </Wizard>
      <div className="flexWrapDiv align-items-center">
        <Link to="/dashboard" className="">
          <button className="icon-btn large-btn">
            <img src={backIcon} alt="" className="me-1" /> Back
          </button>
        </Link>

        <Suspense fallback={null}>
          <div
            style={{
              width: "250px",
            }}
          >
            <LazyProjectList />
          </div>
        </Suspense>
        <div className="ms-auto">
          <GoogleAuth analyticShow={true} />
        </div>
      </div>
      <div className="Google_any_data">
        <div
          className="cmd-b mb-4 d-flex flex-column py-3"
          style={{
            borderRadius: "5px",
            boxShadow: "none",
          }}
        >
          <div className="cmd analy-con-div w-100">
            <div className="flexWrapDiv w-100 align-items-center">
              <h5 className="heading-large mb-0 me-auto">Organic Traffic</h5>
              {property_name?.[0]?.display_name ? (
                <div className="me-3">
                  <span className="heading-medium font-light-bold">
                    Domain:{" "}
                  </span>
                  <span className="font-regular heading-medium">
                    {property_name?.[0]?.display_name}{" "}
                  </span>
                </div>
              ) : null}

              <div className="d-flex me-2 align-items-center">
                <img className="googleIMG" src={googleAnalyticsImg} alt="" />
              </div>
            </div>
          </div>
          {Loader ? (
            <div
              style={{ display: "flex", minHeight: "50px" }}
              className="w-100 h-100 cad"
            >
              <div
                className="spinner-border"
                style={{ color: "#365486" }}
                role="status"
              >
                <span className="sr-only"></span>
              </div>
            </div>
          ) : userAnalyticData?.length === 0 ? (
            userAnalyticLogin ? (
              <div className="w-100 ">
                <div className="w-100">
                  <div
                    style={{
                      position: "relative",
                    }}
                    className="w-100"
                  >
                    <div
                      className="w-100"
                      style={{ maxHeight: "500px", minHeight: "200px" }}
                    ></div>
                    <div
                      className="w-50"
                      style={{ position: "absolute", top: "50%", left: "35%" }}
                    >
                      <span className="heading-medium font-bold">
                        We Are Fetching Your Google Analytics Data Please
                        Wait...
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ) : null
          ) : (
            <div className="w-100">
              <div className="d-flex align-items-center flex-wrap gap-3 mt-3">
                <Tabs
                  value={value}
                  onChange={handleChange}
                  aria-label="icon tabs example"
                  sx={{
                    minHeight: "35px",
                    "& .MuiButtonBase-root": {
                      backgroundColor: "transparent",
                      color: "#191B23",
                    },
                    "& .MuiTabs-indicator": {
                      height: 0,
                    },
                    "& .MuiTab-root.Mui-selected": {
                      color: "rgba(120, 66, 232, 1)",
                      backgroundColor: "#F1ECFD",
                      border: "1px solid #6254FF",
                    },
                    "& .MuiTab-root": {
                      border: "1px solid #C4C7CF",
                      height: "35px",
                      width: "100px",
                      minHeight: "35px",
                      textTransform: "capitalize",
                      fontWeight: "600",
                      fontFamily: "Lato",
                    },
                  }}
                >
                  <Tab
                    label="Default"
                    aria-label="default"
                    id="tab_google"
                    sx={{
                      borderTopLeftRadius: "0.5rem",
                      borderBottomLeftRadius: "0.5rem",
                    }}
                  />
                  <Tab label="Desktop" aria-label="desktop" id="tab_google" />

                  <Tab
                    label="Mobile"
                    aria-label="mobile"
                    id="tab_google"
                    sx={{
                      borderBottomRightRadius: "0.5rem",
                      borderTopRightRadius: "0.5rem",
                    }}
                  />
                </Tabs>
                <div className="justify-content-end d-flex align-items-center ms-auto">
                  <span className="me-2" style={{ color: "#6C6E79" }}>
                    ({dataLoadedFrom})
                  </span>
                  <DropdownMenu
                    {...{
                      menuData: trafficDataMenu,
                      handleSelect: handleDateUpdate,
                    }}
                  />
                </div>
              </div>

              <div
                style={{ maxHeight: "500px", height: "230px" }}
                className="w-100"
              >
                <SingleLineChart data={chart_data} Options={options} />
              </div>
            </div>
          )}
        </div>
      </div>

      {/* {userAnalyticLogin ? ( */}
      <div className="google-console-data">
        <div
          className="cmd-b mb-4 py-3"
          style={{
            display: "flex",
            flexDirection: "column",
            borderRadius: "5px",
            boxShadow: "none",
          }}
        >
          <div className="cmd analy-con-div w-100">
            <div
              className="flexWrapDiv align-items-center w-100"
              style={{ gap: "1rem" }}
            >
              <h5 className="heading-large mb-0">Search Console</h5>

              <div className="analy-gol d-flex align-items-center ms-auto">
                {google_console_data?.length === 0 && !consoleStatus ? (
                  <button onClick={getGoogleConsoleData}>GET DATA</button>
                ) : (
                  <div className="d-flex align-items-center">
                    <img
                      src={googleConsoleImg}
                      alt=""
                      style={{
                        width: "auto",
                        height: "30px",
                        objectFit: "contain",
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
          {siteData?.length > 0 &&
            siteData[0]?.console_data?.length === 0 &&
            getConsole &&
            !consoleStatus && (
              <div className="text-center">
                <p className="mb-0">
                  Sorry! There is No Console property in your Google Account.
                  Please Check your account.
                </p>
                <p>
                  <b>If issue persist please Contact Support.</b>
                </p>
              </div>
            )}
          {siteData?.length === 0 &&
            !userAnalyticLogin &&
            getConsole &&
            !consoleStatus && (
              <div className="text-center">
                <p className="mb-0">
                  Oops! Looks like there is No Console Property. Please Connect
                  Google Account.
                </p>
                <p>
                  <b>If issue persist please Contact Support.</b>
                </p>
              </div>
            )}

          {google_console_data?.length > 0 ? (
            <div className="w-100">
              <div className="w-100 d-flex align-items-center flex-wrap gap-3">
                <div className="d-flex console-chart-box overAuto">
                  {chartShowDataType?.map((item, index) => {
                    return (
                      <div
                        className="console-total point"
                        style={{
                          backgroundColor: item.backgroundColor,
                          borderRight: "1px solid white",
                          color: item.color,
                          borderTopLeftRadius: index === 0 ? "10px" : "0px",
                          borderBottomLeftRadius: index === 0 ? "10px" : "0px",
                          borderTopRightRadius: index === 3 ? "10px" : "0px",
                          borderBottomRightRadius: index === 3 ? "10px" : "0px",
                        }}
                        key={`console-chart-${index}`}
                        onClick={() => handleCheckboxChange(item.datakey)}
                      >
                        <div className="heading-small font-regular d-flex align-items-center">
                          <Checkbox
                            edge="start"
                            checked={item.isShow}
                            tabIndex={-1}
                            disableRipple
                            className="pe-1 py-0"
                            inputProps={{ "aria-labelledby": index }}
                            sx={{
                              color: item.color,
                              "&.Mui-checked": {
                                color: item.color,
                              },
                            }}
                          />{" "}
                          {item.title} : {item.value}
                        </div>
                      </div>
                    );
                  })}
                </div>
                {google_console_data[0]?.site && (
                  <div
                    className="d-flex align-items-center ms-auto heading-medium font-regular"
                    style={{ color: "#6254FF" }}
                  >
                    <span>Domain:</span>
                    <span className="ms-1">
                      {google_console_data[0]?.site?.replace("sc-domain:", "")}{" "}
                    </span>
                    {google_console_data[0]?.date && (
                      <span className="ms-1" style={{ color: "#6C6E79" }}>
                        (Last 3 months)
                      </span>
                    )}
                  </div>
                )}
              </div>
              <div className="overAuto w-100 app-scrollbar">
                <div
                  className="w-100"
                  style={{
                    position: "relative",
                    maxHeight: "500px",
                    height: "300px",
                    minWidth: "600px",
                  }}
                >
                  <SingleLineChart
                    data={con_chart_data}
                    Options={con_options}
                  />
                </div>
              </div>
            </div>
          ) : (
            consoleStatus && (
              <span>
                We Are Fetching Your Search Console Data. Please Wait...
              </span>
            )
          )}
        </div>
      </div>

      {google_console_data?.length > 0 && (
        <Suspense fallback={<FallbackLoader />}>
          <LazySearchConsoleTable
            {...{
              consoleData: google_console_data,
            }}
          />
        </Suspense>
      )}
    </main>
  );
};

export default GoogleData;
